import * as React from 'react';

import { useCtx } from 'one-ui-provider';
import {
  useSelector,
  useDispatch,
} from 'react-redux';

import { ScreenpopProps } from './props';
import Button from "antd/lib/button";
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import {
  setAction as panvivaAction
} from 'one-state-panviva/src/actions';
import {
  PanvivaModel,
} from 'one-state-panviva/src/model';


/**
 * This components reads the screenpop values from settings file and constructs url
 * @param props  contains the selected/active patient ,screenpop respecite to his pages
 */
export const PanvivaComp = (
  props: ScreenpopProps
) => {
  const dispatch = useDispatch();

  const { agentId, settings: { panviva_links, compatible} } = useCtx();
  const { contact_center_type, panviva_sso } = compatible;
  const { map } = panviva_links;
  const panvivasearch = useSelector((state:any)=> (state.panvivasearch));

  /**
   *
   * @param url opens given url in new page
   */
  const popurl = (url: any) => {
    window.open(url);
  }

  const keys = map || [];
  let index = 0;
  const keyComps = [];
  while (index < keys.length) {
    const buttons = [];
    const maxCols = 2;
    for (let colIndex = 0; colIndex < maxCols; colIndex++) {
      if (index < keys.length) {
        let key = keys[index];
        buttons.push(
          <Col span={24 / maxCols} style={{ padding: '2px' }} >
            <li key={index} className="ant-drawer__item">
              <Button className="ant-btn--menu" style={{ fontSize: '1.0rem', whiteSpace: 'normal' }} size="large" block={true} onClick={
                (key.type) ?
                  (() => { 
                    let agentIdValue = agentId;
                    if (contact_center_type && (contact_center_type === 'five9' || contact_center_type === 'genesys' || contact_center_type === 'inContact')) {
                      agentIdValue = sessionStorage.getItem("agentName");
                  }
                    else if(contact_center_type === "genesys") {
                      agentIdValue = sessionStorage.getItem("five9_userid");
                    }
                    else if(contact_center_type === "twilio") {
                      agentIdValue = sessionStorage.getItem("twilio_userid");
                    }
                    if(panviva_sso === false) (
                      agentIdValue = panvivasearch.agentuserid ? panvivasearch.agentuserid : ""
                    )
                    
                    const sobject: PanvivaModel = {
                      key:key.key,
                      panviva_id: agentIdValue,
                      type: key.type ? key.type : "",
                      id: key.id ? key.id : "",
                      location: key.location ? key.location : ""
                    }
                    dispatch(panvivaAction(sobject));
                  }) :
                  (() => { popurl(key.key) })
              }>{key.label}</Button>
            </li>
          </Col>
        );
        index = index + 1;
      }
    }
    keyComps.push(
      <>
        <ul className="ant-drawer__menu">
          <Row>
            {buttons}
          </Row>
        </ul>
      </>
    );
  }

  return (
    <>
    {/* According to ADPAC-2536 */}
    <div className="ant-drawer__subtitle">Panviva HotLinks</div>
      {keyComps}
    </>
  );
};